import {
  type CleanEmptyFoldersRequest,
  type EmptyFoldersScanResult,
  type Job,
  emptyFoldersScanResultSchema,
  jobSchema,
} from '@xphoto/shared';
import { ApiError } from '../gallery/api';
import { LONG_TIMEOUT_MS, apiFetch } from '../lib/http';

/**
 * Client typé du NETTOYAGE DES DOSSIERS VIDES. Les réponses sont RE-PARSÉES via leur
 * schéma partagé — « never trust the client », y compris soi-même.
 */

async function readJson(res: Response): Promise<unknown> {
  if (!res.ok) {
    let code = 'UNKNOWN';
    try {
      const body = (await res.json()) as { error?: { code?: string } };
      if (typeof body?.error?.code === 'string') code = body.error.code;
    } catch {
      /* corps non-JSON : code générique */
    }
    throw new ApiError(res.status, code);
  }
  return res.json();
}

/**
 * `GET …/empty-folders` — compte les répertoires sans aucun fichier (+ échantillon de
 * chemins). LECTURE, synchrone. Accès ÉCRITURE requis (403 sinon) : l'aperçu rend des
 * chemins bruts de toute la bibliothèque et n'a d'utilité que pour qui peut nettoyer.
 */
export async function scanEmptyFolders(libraryId: string): Promise<EmptyFoldersScanResult> {
  const res = await apiFetch(`/api/libraries/${libraryId}/empty-folders`, {
    // Parcours SYNCHRONE de toute l'arborescence disque → plafond long.
    timeoutMs: LONG_TIMEOUT_MS,
  });
  return emptyFoldersScanResultSchema.parse(await readJson(res));
}

/**
 * `POST …/empty-folders/clean` — enfile un job `empty_folders_cleanup` qui supprime les
 * répertoires vides (`rmdir` uniquement). 409 `WRITE_DISABLED` si l'écriture est désactivée.
 */
export async function enqueueCleanEmptyFolders(
  libraryId: string,
  body: CleanEmptyFoldersRequest,
): Promise<Job> {
  const res = await apiFetch(`/api/libraries/${libraryId}/empty-folders/clean`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return jobSchema.parse(await readJson(res));
}
